import './Dialog.scss';
import { init } from './dialog';


document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.js-dialog-disclosure')) {
        init();
    }
});
